import Cookies from 'js-cookie';

export function getGeoIPCode() {
	return (Cookies.get('GeoIPCookie') || '').split('=')[1];
}

export function isInGB() {
	return getGeoIPCode() === 'GB';
}

export function isInChina() {
	return getGeoIPCode() === 'CN';
}

export function isInRussia() {
	return getGeoIPCode() === 'RU';
}
